import { SkeletonBlock } from "./SkeletonBlock.jsx";

export function SkeletonRows({ count = 5, height = 40, gap = 8, style }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap, ...style }}>
      {Array.from({ length: count }, (_, i) => (
        <SkeletonBlock key={i} height={height} />
      ))}
    </div>
  );
}
